module.exports = __webpack_public_path__ + "img/sonargroup-blog.4aa0a0ab.jpg";